import styled from 'styled-components';
import { darkGreen, greyLightBorder, greyLightButton, white } from '../../../../styles/Variables';

interface ButtonProps {
    readonly isActive: boolean;
}

export const Button = styled.button<ButtonProps>`
    background-color: ${(props) => (props.isActive ? white : greyLightButton)};
    width: 100%;
    border-radius: 5px;
    ${(props) =>
        props.isActive
            ? `
        border: 1px solid ${greyLightBorder};
        border-bottom: none;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        padding: 12px 12px 24px 12px;
        min-height: 2.5rem;
    `
            : `
        border: 1px solid ${greyLightBorder};
        height: 2.5rem;
        padding: 12px;
        `}
    cursor: pointer;
    z-index: 1;
    position: relative;
    text-transform: capitalize;
    font-family: Arial, Helvetica, sans-serif;
    max-width: 210px;
`;

export const FilterButtonText = styled.span`
    color: ${darkGreen};
    display: block;
    margin-top: -2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
